import React from 'react';
import Contactimg from "../components/img/Contactimg.jpg";
import './ContactFormBanner.css';

const ContactFormBanner = () => {
  return (
    <div>
      <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={Contactimg} className="d-block w-100 carousel-image" alt="..." />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactFormBanner;
